import * as React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import {
  GridRowModes,
  DataGrid,
  GridToolbarContainer,
  GridToolbar,
  GridActionsCellItem,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
  GridToolbarDensitySelector,
  useGridApiContext,
  gridExpandedSortedRowIdsSelector,
  GridFilterInputSingleSelect
} from "@mui/x-data-grid";
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Button, TextField, debounce } from "@mui/material";
import getAccess from "../utils/getAccess";
import { useTheme } from "@emotion/react";
import * as XLSX from 'xlsx'


const removeComma = (array) => {
  return array.reduce((acc, curr) => acc + " " + curr, "")
};



function CustomToolbar({ rows, columns, loading, setLoading, searchText, setSearchText, ...gridProps }) {
  const apiRef = useGridApiContext();
  const exportAllRows = async () => {
    const visibleRows = gridExpandedSortedRowIdsSelector(apiRef);
    const filteredRows = rows.filter((row) => visibleRows.includes(row.id));
    const columnIds = columns.filter((column) => column.field !== 'actions').map((column) => column.field);
    const csvHeader = columnIds.join(', ');
    const csvContent = filteredRows
      .map((row, index) => {
        const rowValues = columnIds.map((columnId) => {
          if (columnId === 'serialNumber') {
            return index + 1;
          }
          else if (columnId === 'Stream') {
            return removeComma(row.Stream)
          }
          return row[columnId]?.toString().replaceAll(",", " ");
        });
        return rowValues.join(', ');
      })
      .join('\n');
    const fullCsvContent = `${csvHeader}\n${csvContent}`;
    const blob = new Blob([fullCsvContent], { type: `text/csv;charset=utf-8` });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', 'Users.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />

      <GridToolbarDensitySelector />
      <Tooltip title="Export All">
        <IconButton onClick={exportAllRows}>
          <SaveAltIcon style={{ color: 'red' }} />
        </IconButton>
      </Tooltip>
    </GridToolbarContainer>
  );
};

export default function User1() {
  const d = getAccess();
  const theme = useTheme();
  const [rows, setRows] = React.useState([]);
  const [loading1, setLoading1] = React.useState(false)
  const [searchText, setSearchText] = React.useState("");
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [rowCountState, setRowCountState] = React.useState(0);
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 25
  })

  const [filterModel, setFilterModel] = React.useState({ items: [] });
  const [pendingFilter, setPendingFilter] = React.useState("");
  const [loading, setLoading] = React.useState(true);
  const [inputText, setInputText] = React.useState("");
  const navigate = useNavigate();
  const mapPageToNextCursor = React.useRef({});
  const queryOptions = React.useMemo(
    () => ({
      cursor: mapPageToNextCursor.current[paginationModel.page - 1],
      pageSize: paginationModel.pageSize,
    }),
    [paginationModel],
  );
  React.useEffect(() => {
    const handler = (e) => {
      const isFilterInputFocused =
        document.activeElement?.closest(".MuiDataGrid-filterForm");

      if (e.key === "Enter" && isFilterInputFocused) {
        setSearchText(pendingFilter);
        setPaginationModel((p) => ({ ...p, page: 0 }));
      }
    };

    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [pendingFilter]);

  const handleDownload = async () => {
    const token = localStorage.getItem("token");
    setLoading1(true);
    const fullResponse = await fetch(
      `${process.env.REACT_APP_LIVE_URL}/adminPanel/getAllStudentList`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const responseJson = await fullResponse.json();
    const worksheet = XLSX.utils.json_to_sheet(responseJson?.data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, 'AllUsers.xlsx');
    setLoading1(false);
  }

  React.useEffect(() => {
    const token = localStorage.getItem("token");

    async function fetchUsers() {
      setLoading(true);

      const res = await fetch(
        `${process.env.REACT_APP_LIVE_URL}/adminPanel/getStudents?page=${paginationModel.page}&pageSize=${paginationModel.pageSize}&searchText=${searchText}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          }
        }
      );

      const json = await res.json();

      setRows(json.data?.studentList || []);
      setRowCountState(json.data?.count || 0);

      setLoading(false);
    }

    fetchUsers();
  }, [paginationModel.page, paginationModel.pageSize, searchText]);


  const handlePaginationModelChange = (newPaginationModel) => {
    setPaginationModel(newPaginationModel);
  };

  React.useEffect(() => {
    if (!loading) {
      // We add nextCursor when available
      mapPageToNextCursor.current[paginationModel.page] = paginationModel.page + 1;
    }
  }, [paginationModel.page, loading]);

  const handleChange = (e) => {
    setSearchText(e.target.value)
  }

  // const debounceHandleChange = debounce(handleChange , 500);

  const handleEditClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleSaveClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };


  const handleCancelClick = (id) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row) => row.id === id);
    if (editedRow.isNew) {
      setRows(rows.filter((row) => row.id !== id));
    }
  };

  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
    return updatedRow;
  };

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const rowsWithSerialNumber = rows?.map((row, index) => ({
    ...row,
    serialNumber: index + 1,
  }));
  const makeVerifiedAndUnVerifiedUser = async (id) => {

    const token = localStorage.getItem("token");
    const response = await fetch(`${process.env.REACT_APP_LIVE_URL}/adminSection/makeVerifiedAndUnVerifiedUser/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },

    });
    const responseJson = await response.json();
    if (responseJson?.status) {
      toast.success(responseJson.msg)
      setTimeout(() => window.location.reload()
        , 1000)
    } else {
      toast.error(responseJson.msg);
    }


  }

  const columns = [
    {
      field: "serialNumber",
      headerName: "S NO",
      width: 75,
      align: "left",
      headerAlign: "left",
      // editable: false,
      renderCell: (params) => <strong>{params.value}</strong>,
    },

    {
      field: "enrollId",
      headerName: "Enroll Id",
      type: "string",
      width: 100,
      align: "left",
      headerAlign: "left",
      // editable: true,
    },
    {
      field: "userId",
      headerName: "User Id",
      type: "object",
      width: 350,
      align: "left",
      headerAlign: "left",
      // editable: true,
      renderCell: (params) => (
        <div>{params.value ?? "NA"}</div>
      ),
    },
    {
      field: "FullName",
      headerName: "Name",
      type: "object",
      width: 150,
      align: "left",
      headerAlign: "left",
      // editable: true,
    },
    {
      field: "mobileNumber",
      headerName: "Phone No",
      type: "object",
      width: 150,
      align: "left",
      headerAlign: "left",
      // editable: true,
      renderCell: (params) => (
        <div>{params.value ? params.value : "NA"}</div>
      ),
    },

    {
      field: "utm_campaign",
      headerName: "Utm Campaign",
      type: "object",
      width: 250,
      align: "left",
      headerAlign: "left",
      // editable: true,
    },
    {
      field: "utm_source",
      headerName: "Utm Source",
      type: "object",
      width: 250,
      align: "left",
      headerAlign: "left",
      // editable: true,
    },
    {
      field: "utm_medium",
      headerName: "Utm Medium",
      type: "object",
      width: 250,
      align: "left",
      headerAlign: "left",
      // editable: true,
    },
    {
      field: "mobileNumberVerified",
      headerName: "isMobileVerified",
      type: "object",
      width: 250,
      align: "left",
      headerAlign: "left",
      // editable: true,
      renderCell: (params) => (
        <div style={{ color: params.value == true ? 'green' : 'red' }}>
          {params.value === true ? 'Verified' : 'Not Verified'}
        </div>
      ),
    },
    {
      field: "Stream",
      headerName: "Category",
      type: "object",
      width: 450,
      align: "left",
      headerAlign: "left",
      // editable: true,
      renderCell: (params) => (
        <div style={{ display: 'flex' }}>
          {params.value.map((title, index) => (
            <div>{title} ,</div>

          ))}
        </div>
      )
    },
    {
      field: "created_at",
      headerName: "Register At",
      type: "Date",
      width: 150,
      align: "left",
      headerAlign: "left",
      // editable: true,
    },
    {
      field: "is_active",
      headerName: "Status",
      type: "boolean",
      width: 100,
      align: "left",
      headerAlign: "left",
      // editable: true,
      renderCell: (params) => (
        <div style={{ color: params.value == true ? "green" : "red" }}>
          {params.value ? "Active" : "inActive"}
        </div>
      ),
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 150,
      cellClassName: "actions",
      getActions: ({ id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
        const rowData = rows.find((item) => item.id == id);

        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              sx={{
                color: "primary.main",
              }}
              onClick={handleSaveClick(id)}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(id)}
              color="inherit"
            />,
          ];
        }

        return [
          (d?.accessForTab?.includes('readWrite') || d?.accessForTab?.includes('read') || d?.access?.includes('all')) ?
            <GridActionsCellItem
              icon={<VisibilityOutlinedIcon />}
              label="View"
              onClick={() => navigate(`/dashboard/students/studentsProfile/${id}`)}
              color="inherit"
            /> : <></>,
          // ((access?.deleteAccess || access?.accessForTab == 'readWrite' || access?.access.includes('all')) ?
          <Tooltip title={`${rowData?.isVerified == true ? 'Make UnVerified' : 'Make Verified'}`}>
            <GridActionsCellItem
              icon={rowData?.isVerified == true ? <ToggleOffIcon style={{ color: 'green' }} /> : <ToggleOnIcon style={{ color: 'red' }} />}
              label="Change Status"
              onClick={() => makeVerifiedAndUnVerifiedUser(id)}
              color="inherit"
            />
          </Tooltip>,
          //  : <></>),
        ];
      },
    },
  ];



  return (
    <Box
      sx={{
        height: 500,
        width: "100%",
        "& .actions": {
          color: "text.secondary",
        },
        "& .textPrimary": {
          color: "text.primary",
        },
      }}
    >
      <Stack direction='row' spacing={3} justifyContent='space-between' m={2} mr={10} sx={{ width: '90%', }}>
        <h2>All Users</h2>
        {/* {(d?.accessForTab.includes("read") || d?.accessForTab.includes("readWrite") ||
          d?.access.includes("all")) && (
            <Button
              variant="contained"
              sx={{
                width: "20%",
                alignSelf: "center",
                margin: '50px',
                background: theme.palette.primary.mainTheme,
                "&:hover": { background: "red" },
              }}
              disabled={loading1}
              onClick={() => handleDownload()}
            >
              {loading1 ? 'Downloading....' : `Download All User `}
            </Button>
          )} */}
      </Stack>
      {/* <Box mb={2}>
        
      </Box> */}
      <Box m={2}>
        <TextField
          sx={{ width: 400 }}
          value={inputText}
          placeholder="Search User Text and Press Enter"
          onChange={(e) => setInputText(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              setSearchText(inputText);
              setPaginationModel((prev) => ({ ...prev, page: 0 }));
            }
          }}
        />
      </Box>

      <DataGrid
        rows={rowsWithSerialNumber}
        columns={columns}
        loading={loading}

        paginationMode="server"
        rowCount={rowCountState}

        filterMode="server"
        filterModel={filterModel}
        onFilterModelChange={(model) => {
          setFilterModel(model);
          const value = model.items?.[0]?.value || "";
          setPendingFilter(value);
        }}
        paginationModel={paginationModel}
        onPaginationModelChange={handlePaginationModelChange}

        pageSizeOptions={[25, 50, 100]}

        editMode="row"
        rowModesModel={rowModesModel}
        onRowModesModelChange={handleRowModesModelChange}
        processRowUpdate={processRowUpdate}

        slots={{
          toolbar: (gridProps) => (
            <CustomToolbar
              {...gridProps}
              rows={rows}
              columns={columns}
            />
          ),
        }}
      />
      <ToastContainer
        position="bottom-center"
        autoClose={1000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </Box>
  );
}